module.exports = __webpack_public_path__ + "fonts/Source-Sans-Pro-Bold.b03f2ec2.woff";